import View from './view.js'
import React from 'react'
import { useDataIsSubmitting, useDataFormat } from 'Simple/Data'

export default function Logic(props) {
  let isSubmitting = useDataIsSubmitting({
    viewPath: props.viewPath,
    context: 'new_phone',
  })

  let shouldDisable = useDataFormat({
    context: 'new_phone',
    viewPath: props.viewPath,
    format: phone =>
      phone.type === 'existing'
        ? !phone.contact_method_id
        : !phone.phone.number || !phone.phone.type,
  })

  return <View {...props} disabled={shouldDisable || isSubmitting} />
}
